<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="nonindent" style="margin-top: 2em;"><span class="big2"><strong>‘I thought the storm was over.’</strong></span></p>
<p class="extract">With a move so smooth she didn’t even feel it happening Kaden had put his hands on her arms and pulled her closer. Their bodies were almost touching.</p>
<p class="extract">‘I think the storm is just beginning.’</p>
<p class="extract">For a second confusion made Julia’s head foggy. She couldn’t seem to be able to separate out his words. And then she realised—when she saw how hot his gaze had become and how it moved down to her mouth. Desire was stamped onto the stark lines of his face and Julia’s heart beat fast in response. Because it was a look that had haunted her dreams for ever.</p>
<p class="extract">Desperately trying to fight the waves of need beating through her veins, she shook her head and tensed, trying to pull back out of Kaden’s grip.</p>
<p class="extract">‘Kaden, <em>no</em>. I shouldn’t be here…We shouldn’t have met again.’</p>
<p class="extract">Kaden shook his head, and a tiny harsh smile touched his mouth. ‘From the moment we stood in front of each other in that room the possibility of <em>this</em> has existed.’</p>
<p class="extract">Bitterness rang in Julia’s voice. ‘The possibility of <em>this</em> stopped existing twelve years ago in Burquat—or have you forgotten what happened?’</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781460346396_epub_exc_r1.vue?12034a71